import React from "react";
import {
  TComponentDetails,
  TBannerProps,
} from "../../types/ContentHubSeriesDetails.type";
import Gallery from "./Gallery";
import VideoPlayer from '../../../../react-only-components/VideoPlayer';

const getBannerType = (component: TComponentDetails) => {
  if (component?.videoUrl && component?.videoUrl !== "") {
    return "video";
  }
  if (component?.assets && component?.assets.length > 1) {
    return "gallery";
  }
  if (component?.assets && component?.assets.length === 1) {
    return "image";
  }
  return "none";
};

const Banner = (props: TBannerProps) => {
  const model = props.component;
  const hasFixedAspectRatio = props?.hasFixedAspectRatio || false;
  const bannerType = getBannerType(props.component);

  if (bannerType === "none") {
    return <></>;
  }

  return (
    <div className={`component-details-banner ${props.className}`}>
      <div className="component-details-banner__content">
        {(bannerType === "video" && model?.videoUrl) ? (
          <VideoPlayer
            link={model?.videoUrl}
            title={model?.videoDescription}
            width={100}
            height={100}
          />
        ) : bannerType === "gallery" ? (
          <Gallery
            assets={model?.assets}
            hasFixedAspectRatio={hasFixedAspectRatio}
          />
        ) : bannerType === "image" ? (
          <div
            className={`component-details__image-wrapper ${
              hasFixedAspectRatio
                ? "component-details__image-wrapper--16-9"
                : ""
            }`}
          >
            <img
              className="component-details__image"
              alt={model?.assets?.[0]?.alt}
              src={model?.assets?.[0]?.full}
            />
          </div>
        ) : (
          <></>
        )}
      </div>
    </div>
  );
};

export default Banner;
